export default __webpack_public_path__ + "static/media/edit-circle.7c08cdc0.svg";